import SimpleQuestion from "./SimpleQuestion";
import * as theme from "../theme";
import { NumericFormat } from "react-number-format";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { useEffect, useState } from "react";
import { isAnswerEmpty } from "../store/helperfuncs";
import { AiFillCalculator } from "react-icons/ai";
import PercentageCalculator from "./PercentageCalculator";

const Currency = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      rightComponent={
        <>
          <NumberInput
            node={node}
            handleAnswerChange={handleAnswerChange}
            qfusermode={qfusermode}
          ></NumberInput>
          {node.id == "47060" ? (
            <PercentageCalculator qfusermode={qfusermode} parentNode={node}>
              {" "}
            </PercentageCalculator>
          ) : null}
        </>
      }
    ></SimpleQuestion>
  );
};

const NumberInput = ({
  node,
  handleAnswerChange,
  error,
  label,
  qfusermode,
}) => {
  // const currentnode = useSelector(getCurrentNode);
  // const isOnThisNode = node.id === currentnode.id;
  const [input, setInput] = useState(
    isAnswerEmpty(node.answer) ? null : node.answer
  );

  useEffect(() => {
    if (input != node.answer && node.answer) {
      setInput(node.answer);
    }
  }, [node.answer]);

  const handleAnswer = (input) => {
    if (input === "" || input === null) {
      handleAnswerChange(null);
    } else if (!isNaN(input)) {
      handleAnswerChange(Number(input));
    }
  };

  const handleBlur = (event) => {
    if (node.answer != input) handleAnswer(input);
  };

  const handleChange = (event) => {
    let input = event.value;
    if (input === "" || input === null || input === undefined) {
      setInput(null);
    } else if (!isNaN(input)) setInput(input);
  };

  // const dispatch = useDispatch();

  return (
    <NumericFormat
      type="text"
      placeholder={"$"}
      prefix={"$"}
      thousandSeparator={true}
      inputmode="numeric"
      id={"numberInput" + node.id}
      style={{ ...theme.inputStyle, width: "9vw" }}
      value={input}
      onValueChange={handleChange}
      onBlur={handleBlur}
      readOnly={qfusermode === INSURER ? true : false}
    ></NumericFormat>
  );
};

export const CurrencyInputForMiniForm = ({
  node,
  handleAnswerChange,
  code,
  questionid,
  qfusermode,
}) => {
  // code = "ENGLISH";
  // questionid = "internal_1";
  // node = {
  //   answer: { internal: { ENGLISH: { internal_1: "hello this is answer" } } },
  // };
  const decideTheValue = (code, node, questionid) => {
    if (!node) return "";
    if (!node.answer) return "";
    if (!node.answer.internal) return "";
    if (!node.answer.internal[code]) return "";
    if (!node.answer.internal[code][questionid]) return "";

    return node.answer.internal[code][questionid];
  };

  const handleAnswer = (event) => {
    let input = event.value;

    console.log(input);
    if (!isNaN(input)) {
      handleAnswerChange(code, questionid, Number(input));
    }
  };
  return (
    <NumericFormat
      type="text"
      placeholder={"$"}
      prefix={"$"}
      thousandSeparator={true}
      inputmode="numeric"
      id={"numberInput" + node.id}
      style={{ ...theme.inputStyle, width: "9vw" }}
      value={decideTheValue(code, node, questionid)}
      onValueChange={handleAnswer}
      readOnly={qfusermode === INSURER ? true : false}
    ></NumericFormat>
  );
};

export default Currency;
